"use client";

import useMixpanelPageView from "@/hooks/utils/useMixpanelPageView";
import React from "react";

interface Props {
  pageName: string;
  options?: any;
}

const MixpanelPageView = (props: Props) => {
  useMixpanelPageView(props);

  return <></>;
};

export default MixpanelPageView;
